import React from 'react'
import QualityScoreBoostForm from './form'

export default function (props) {
  const data = { active: false, ns_f: '0', sr_f: '0', ns_m: '0', sr_m: '0' }

  return (
    <QualityScoreBoostForm data={data} {...props} />
  )
}